module.exports = __webpack_public_path__ + "static/media/img.073416f8.jpg";